import { render, staticRenderFns } from "./ValidationPage.vue?vue&type=template&id=2d173f6e&scoped=true&"
import script from "./ValidationPage.vue?vue&type=script&lang=js&"
export * from "./ValidationPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d173f6e",
  null
  
)

export default component.exports